export default "__VITE_ASSET__b5d0fd10__"